import React, { useCallback } from "react";
import MatesList from "./matesList";

const MainNav = (props) => {
  const mainNavTrigger = useCallback(() => {
    let oldState = props.mainNavToggle;
    props.setMainNavToggle(!oldState);
  }, [props]);

  return (
    <div className={`mates ${props.mainNavToggle ? "mates--close" : ""} `}>
      <button onClick={() => mainNavTrigger()} className="mates__btn">
        Chats
      </button>

      {props.userMates && props.userMates.length > 0 ? (
        <ul className="mates__list">
          {props.userMates.map((chat, key) => (
            <MatesList
              key={key}
              chatId={chat}
              userId={props.userId}
              userMates={props.userMates}
            />
          ))}
        </ul>
      ) : (
        <div className="mates__empty">
          <p>Tu n'as pas encore de conversations en cours.</p>
        </div>
      )}
    </div>
  );
};

export default MainNav;
